import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IKundeResponse, KundeQueryFilterConfig } from 'fa-kt.types';

import { KundeService } from '../service';

@Component({
  selector: 'fa-kt-kunde-filter',
  templateUrl: './kunde-filter.component.html',
  styleUrls: ['./kunde-filter.component.css'],
})
export class KundeFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public KundeFilterConfig: IFilterConfig<IKundeResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kunde: KundeService,
  ) {
    this.KundeFilterConfig = KundeQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.KundeFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.KundeFilterConfig[index].selections = shapes;
  }
}
